<template>
  <div class="product-list-overlay">
    <div id="product-list" class="product-list">
      <div class="header-container" :class="brand.name">
      <div class="heading" :class="brand.name">{{ getTitle }}</div>
      </div>
      <div class="purchase-container" :class="brand.name">
        <div class="mtc-item-hdr">
          <div>{{ getColumnTitle }}</div>
          <div class="numeric-hdr" :class="brand.name">{{ estimatedPriceLabel }}</div>
          <div class="numeric-hdr" :class="brand.name">{{ totalSavingsLabel }}</div>
          <div class="numeric-hdr" :class="brand.name">{{ onlinePriceLabel }}</div>
          <div></div>
        </div>
        <div class="mtc-item-hdr-line">
        </div>
        <div v-if="loading" class="loading-spinner">
          Retrieving Available {{ this.brand[category].planTitle }} ...
          <div class="spinner-border">
          </div>
        </div>
        <SelectedProductItem v-for="product in sortedProduct"
        :product="product" :brand="brand" :dealer="dealer" :step="step" :category="category"
        v-bind:key="product.product_id" offer-type="select" :maxInterval="maxInterval">
        </SelectedProductItem>
      </div>
    </div>
  </div>
</template>

<script>
import SelectedProductItem from '@/components/ecomm/product/SelectedProductItem'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'FilteredProductList',
  data () {
    return {
      loading: true
    }
  },
  props: {
    brand: Object,
    dealer: Object,
    step: Number,
    category: String
  },
  components: {
    SelectedProductItem
  },
  computed: {
    ...mapState({
      productVariants: state => state.productVariants,
      prepaidMaintenance: state => state.prepaidMaintenance
    }),
    ...mapGetters({
      getSelectedProductsByCategory: ['productVariants/getSelectedProductsByCategory']
    }),
    getCategoryLabel () {
      return `${this.category[0].toUpperCase()}${this.category.slice(1).toLowerCase()}`
    },
    getTitle () {
      if (this.category === 'maintenance') {
        return `${this.dealer.name} Prepaid ${this.getCategoryLabel} Products`
      } else {
        return `${this.dealer.name} ${this.getCategoryLabel} Products`
      }
    },
    getColumnTitle () {
      if (this.category === 'maintenance') {
        return `Available ${this.getCategoryLabel} Plans`
      } else {
        return `Available ${this.getCategoryLabel} Products`
      }
    },
    sortedProduct () {
      const sortedProduct = this.getSelectedProductsByCategory(this.category).filter((item) => item.visible === 'yes')
      // sort by price so the highest value item is on top
      sortedProduct.sort((sortedProduct, item) => (sortedProduct.variant_unit_amount && sortedProduct.variant_unit_amount.amount && sortedProduct.variant_unit_amount.amount < item.variant_unit_amount.amount ? 1 : -1))
      return sortedProduct
    },
    maxInterval () {
      // dynamically set the number of columns to display in the grid to the max intervals accross all offers
      const maxInterval = this.getSelectedProductsByCategory(this.category)
        .map(item => item.interval)
        .reduce((max, item) => (max || 0) > item ? max : item)
      return maxInterval
    },
    haveSavings () {
      let haveSavings = false
      for (let i = 0; i < this.sortedProduct.length; i++) {
        if ((+this.sortedProduct[i].variant_unit_amount.amount - +this.sortedProduct[i].variant_unit_amount.retail_amount) < 0) {
          haveSavings = true
        }
      }
      return haveSavings
    },
    estimatedPriceLabel () {
      if (this.category === 'maintenance') {
        if (this.haveSavings) {
          return `Unplanned ${this.getCategoryLabel} Price Estimate`
        } else { return '' }
      } else {
        return `${this.getCategoryLabel} List Price`
      }
    },
    totalSavingsLabel () {
      if (this.haveSavings) {
        return 'Total Savings'
      } else { return '' }
    },
    onlinePriceLabel () {
      if (this.category === 'maintenance') {
        return 'Plan Price'
      } else {
        return `${this.getCategoryLabel} Online Price`
      }
    }
  },
  created () {
    if (this.brand[this.category] && this.brand[this.category].showPlanIntervals) {
      if (this.productVariants.hasProduct && this.prepaidMaintenance.hasService) {
        this.loading = false
      }
    } else if (this.productVariants.hasProduct) {
      this.loading = false
    }
  },
  watch: {
    'productVariants.hasProduct': function () {
      this.loading = !this.productVariants.hasProduct && !this.prepaidMaintenance.hasService
    },
    'prepaidMaintenance.hasService': function () {
      this.loading = !this.productVariants.hasProduct && !this.prepaidMaintenance.hasService
    }
  }
}
</script>
<style scoped>
.heading {
  font-size: 1em;
  line-height: 1.2;
  font-family: var(--title-font-stack);
  margin-bottom: 10px;
  font-weight: bold;
}
.heading.bmw,
.heading.mini {
  text-transform: uppercase;
}
.heading.mini {
  text-align: left;
}
.step-details {
  margin-bottom: 20px;
}
.product-list-overlay {
  display: flex;
  text-align: center;
  flex-direction: column;
  background-color: #ffffff;
  padding: 5px;
  width: 100%; /* sets form size */
}
.product-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px;
  width: 100%; /* defers form size to maintenance-overlay width */
}
.header-container,
.purchase-container {
  width: 100%;
}
.mtc-item-hdr {
  display: none;
  font-size: 0.9rem;
  font-weight: bold;
  text-align: left;
  padding: 20px 0px;
  grid-template-columns: auto 15% 15% 15% 10%;
  column-gap: 10px;
  align-items: end;
}
.mtc-item-hdr-line {
  border-bottom: 1px solid #000000;
}
.numeric-hdr {
  text-align: center;
}
.numeric-hdr.mini {
  text-align: left;
}
/* styles for different screen widths follow */
@media only screen and (min-width: 576px) {
}
@media only screen and (min-width: 768px) {
  .mtc-item-hdr {
    display: grid;
    grid-template-columns: auto 15% 15% 15%;
  }
}
@media only screen and (min-width: 992px) {
  .header-container,
  .purchase-container {
    width: 80%;
  }
  .mtc-item-hdr {
    grid-template-columns: auto 12% 12% 12% 150px;
  }
}
@media only screen and (min-width: 1200px) {
  .mtc-item-hdr {
    grid-template-columns: auto 15% 15% 15% 150px;
  }
}
</style>
